import React, { useEffect, useState } from "react";
import { Tag } from "primereact/tag";
import { DataTable } from "primereact/datatable";
import moment from "moment";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import useDebounce from "../../components/hooks/useDebounce";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import { toast } from "react-toastify";
import { exportToExcel, renderTextWithTooltip } from "../../components/helper";
import Dots from "../../../../assets/assests/detail.png";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Details from "./details_financial";
const FinancialReconciliationReport = ({
  globalFilter,
  exportCSV,
  fromDate,
  toDate,
}) => {
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
 const [rowselect, setRowselect] = useState(null);
  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getReportData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/kiosks/financial-report/get-all-paginated`,
        {
          params: {
            pageNumber,
            pageSize,
            searchTerm: debouncedSearch || "",
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getReportData(pageNumber, rows);
  };

  useEffect(() => {
    getReportData();
  }, [debouncedSearch, fromDate, toDate]);
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }
  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons">
       
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>

      </div>
    );
  };

  const columnsData = [
    // {
    //   field: "kioskId",
    //   header: "kiosk ID",
    //   body: (rowData) => rowData.kioskId || "--",
    // },
    {
      field: "kioskName",
      header: "kiosk Name",
      body: (rowData) => renderTextWithTooltip(rowData, "kioskName", "bottom"),
    },
    // {
    //   field: "kioskLocation",
    //   header: " kiosk Location",
    //   body: (rowData) => rowData.kioskLocation || "--",
    // },
    {
      field: "kioskBranch",
      header: " kiosk Branch",
      body: (rowData) => rowData.kioskBranch || "--",
    },
    {
      field: "transactionType",
      header: "transaction Type",
      body: (rowData) => rowData.transactionType || "--",
    },
    {
      field: "amount",
      header: "amount",
      body: (rowData) => rowData.amount || "--",
    },
    {
      field: "status",
      header: "status",
      body: (rowData) => (
        <Tag
          className={
            rowData.status === "Completed"
              ? "custom-success-tag"
              : "custom-info-tag"
          }
          value={rowData.status ?? "--"}
        />
      ),
    },
    {
      field: "date",
      header: " Date",
      body: (rowData) =>
        rowData.date
          ? moment(rowData.date).format("YYYY-MM-DD HH:mm:ss")
          : "--",
    },
    // {
    //   field: "createdDate",
    //   header: " created Date",
    //   body: (rowData) =>
    //     rowData.createdDate
    //       ? moment(rowData.createdDate).format("YYYY-MM-DD HH:mm:ss")
    //       : "--",
    // },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];

  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/kiosks/financial-report/get-all`
      );
      exportToExcel(response.data.body, columnsData, "FinancialReportData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);

  return (
    <>
       <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Financial Reconciliation Report Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
};

export default FinancialReconciliationReport;
